var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 8.95817C10.3465 8.95817 10.6263 9.23799 10.6263 9.58317V13.7498C10.6263 14.095 10.3465 14.3748 10.0013 14.3748C9.65612 14.3748 9.3763 14.095 9.3763 13.7498V9.58317C9.3763 9.23799 9.65612 8.95817 10.0013 8.95817Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4277 5.78435C10.6843 6.01526 10.7051 6.41045 10.4742 6.66701L10.4659 6.67627C10.2349 6.93284 9.83977 6.95364 9.5832 6.72273C9.32663 6.49182 9.30583 6.09664 9.53674 5.84007L9.54508 5.83081C9.77599 5.57424 10.1712 5.55344 10.4277 5.78435Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.2915C5.74411 2.2915 2.29297 5.74264 2.29297 9.99984C2.29297 14.257 5.74411 17.7082 10.0013 17.7082C14.2585 17.7082 17.7096 14.257 17.7096 9.99984C17.7096 5.74264 14.2585 2.2915 10.0013 2.2915ZM1.04297 9.99984C1.04297 5.05229 5.05375 1.0415 10.0013 1.0415C14.9489 1.0415 18.9596 5.05229 18.9596 9.99984C18.9596 14.9474 14.9489 18.9582 10.0013 18.9582C5.05375 18.9582 1.04297 14.9474 1.04297 9.99984Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoEmpty);
export default __webpack_public_path__ + "static/media/info-empty.4f7e87c5a07031c587da9318d8084204.svg";
export { ForwardRef as ReactComponent };